module.exports = __webpack_public_path__ + "img/icon-medical-shield.ec1e750b.png";